import {
  Input,
  ChangeDetectionStrategy,
  Component,
  ViewChild,
  AfterViewInit,
  OnDestroy,
  HostBinding,
} from '@angular/core';

import { E2E_ATTRIBUTES } from '@app/shared/types/enums/e2e-attributes.enum';

import { ModalDirective } from './core-modal.directive';
import { ModalRefType } from './enums/modal-ref-type.enum';
import { CoreModalService } from './services/core-modal.service';

/**
 * ModalContainer
 */
@Component({
  selector: 'modal-container',
  template: '<ng-template modal-host></ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ModalContainer implements AfterViewInit, OnDestroy {
  @HostBinding('attr.e2e-attr')
  public e2eAttr: string = E2E_ATTRIBUTES.MODAL_CONTAINER;
  @ViewChild(ModalDirective, { static: true }) public modalHost: ModalDirective;
  @Input() public refType = ModalRefType.HOST;

  public constructor(private coreModalService: CoreModalService) {}

  public ngAfterViewInit() {
    if (this.refType === ModalRefType.HOST) {
      this.coreModalService.setContainerRef(this.modalHost.viewContainerRef);
    } else {
      this.coreModalService.setChildContainerRef(
        this.modalHost.viewContainerRef,
      );
    }
  }

  public ngOnDestroy() {
    if (this.refType === ModalRefType.HOST) {
      this.modalHost.viewContainerRef.remove();
      this.coreModalService.removeContainerReference();
    }
  }
}
